export const itemsOnDesktop = 5;
export const itemsOnTablet = 4;

export const getCategoriesInSlideCount = (isTablet: boolean) => {
  const rows = 2;
  const categoriesInSlideCount = rows * (isTablet ? itemsOnTablet : itemsOnDesktop);

  return categoriesInSlideCount;
};
